import React from "react";
import { useAccount } from "../../Contexts/AccountContext";
import { SubLineItemDto } from "../../Models";

interface EventCardProps {
    event: SubLineItemDto;
}

export default ({ event }: EventCardProps) => {
    const { dictionary } = useAccount();
    
    return (
        <div className="card">
            <div className="card-header">
                {event.override?.titleOverride || event.performanceDescription || 'Event'}
            </div>
            <div className="card-body">
                <div className="card-text">
                    <div className="row">
                        {event.performanceDateTime && (
                            <div className="col-sm-4">
                                <small className="text-muted">
                                    {dictionary.get("MyAccount:ClassNEvents:Time") ?? 'Time'}
                                </small>
                                <div>
                                    <small className="text-dark fw-bold">
                                        <i className="fas fa-calendar-alt"></i> {new Date(event.performanceDateTime).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
                                    </small>
                                </div>
                            </div>
                        )}
                        {event.children && event.children.length > 0 && (
                            <div className="col-sm-8">
                                <small className="text-muted">
                                    {dictionary.get("MyAccount:ClassNEvents:Attendee") ?? 'Attendee'}{event.children.length == 1 ? '' : 's'}
                                </small>
                                <div>
                                    {event.children.map((child, idx) => {
                                        return (
                                            <small key={idx} className="fw-bold text-body d-block">
                                                {child}
                                            </small>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/*event.override?.shortDescription && (
                    <div className="card-text text-muted" dangerouslySetInnerHTML={{__html: event.override.shortDescription}}></div>
                )*/}
            </div>
        </div>
    );
};
